import React from 'react';

import CommonLayout from 'components/CommonLayout';
import Body from 'containers/ContactUsPage/Body';
import messages from 'containers/ContactUsPage/messages';
import { AssuranceIcon } from 'images';

const ContactUsPage = () => {
  return (
    <CommonLayout
      title={messages.title_ContactUs}
      icon={<img alt="" src={AssuranceIcon['contactIcon']} />}
      content={<Body />}
    />
  );
};

export default ContactUsPage;
